import './QSFLandingPage.style.less'
import { Col, Row } from 'antd'
import { Outlet, useNavigate } from 'react-router-dom'

import QSFMenuTile from './components/QSFMenuTile/QSFMenuTile'
import { useQuery } from 'react-query'
import { useAtom } from 'jotai'
import { activeTileInspectionAtom } from '@/jotai/qsf.jotai'
import { InspectionConstant } from '../Inspection/Inspection.constant'
import { InspectionGroupStatus } from '@/constant/qsf'
import Header from '@/layout/components/Header'
import { FileSearchOutlined } from '@ant-design/icons'
import { useEffect } from 'react'
import { getUrlParams, setUrlParams } from '@/utils/common'
const defaultSummaryValue = {
  total: 0,
  total_active: 0,
  total_submitted: 0,
}

function QSFLandingPage() {
  const { ACTIVE } = InspectionGroupStatus

  const [activeTile, setActiveTile] = useAtom(activeTileInspectionAtom)
  const { data: summary = defaultSummaryValue } = useQuery(
    [InspectionConstant.QUERY_KEY.INSPECTION_SUMMARY],
    async () => {}
  )

  const navigate = useNavigate()

  const onSetTiles = (value) => {
    navigate({
      search: `?${setUrlParams('group', value ?? '')}`,
    })
    navigate({
      search: `?${setUrlParams('page', '1')}`,
    })

    setActiveTile(value)
  }

  useEffect(() => {
    setActiveTile(getUrlParams('group') || ACTIVE)
  }, [])

  return (
    <>
      <Header
        icon={<FileSearchOutlined className="icon" />}
        title={'My Quality'}
        background="linear-gradient(181.35deg, #E67E22 1.15%, rgba(239, 151, 71, 0.9) 98.85%)"
      />

      <div className="qsf-landing-page-container">
        <Row
          className="qsf-summary-tiles"
          justify="space-between"
          align="middle"
          gutter={[
            { xs: 12, sm: 12, md: 16 },
            { xs: 12, sm: 16, md: 16 },
          ]}
        >
          <Col xs={12} sm={8}>
            <QSFMenuTile
              title="All Inspections"
              qty={`${summary?.total || 0}`}
              isActive={activeTile === InspectionGroupStatus.ALL}
              onPress={() => onSetTiles(InspectionGroupStatus.ALL)}
            />
          </Col>
          <Col xs={12} sm={8}>
            <QSFMenuTile
              title="Active Inspections"
              qty={`${summary?.total_active || 0}`}
              isActive={activeTile === InspectionGroupStatus.ACTIVE}
              onPress={() => onSetTiles(InspectionGroupStatus.ACTIVE)}
            />
          </Col>
          <Col xs={12} sm={8}>
            <QSFMenuTile
              title="Submitted Inspections"
              qty={`${summary?.total_submitted || 0}`}
              isActive={activeTile === InspectionGroupStatus.COMPLETED}
              onPress={() => onSetTiles(InspectionGroupStatus.COMPLETED)}
            />
          </Col>
        </Row>
        <div style={{ marginTop: 18 }}>
          <Outlet />
        </div>
      </div>
    </>
  )
}

export default QSFLandingPage
